import {DomainEvent} from './DomainEvent';
import {Season} from '../resources/Season';

export class SeasonUpdated extends DomainEvent<Season> {}
